import { noddiAsync, URLKeys } from 'noddi-async';
import { useBookingAddress, useBookingSelectedSalesItemsCars } from 'noddi-web';

// Department that would execute the mobile booking drafted so far. Unknown
// until both an address and at least one sales item are picked.
export function useBookingSummaryServiceDepartment() {
  const salesItems = useBookingSelectedSalesItemsCars();
  const addressId = useBookingAddress()?.id;

  return noddiAsync.useGet({
    type: URLKeys.getServiceDepartmentFromBookingSummary,
    input: {
      addressId: addressId ?? 0,
      salesItemsIds: salesItems.map((item) => item.salesItemId)
    },
    queryConfig: {
      enabled: addressId != null && salesItems.length > 0
    }
  });
}
